import { useCallback, useState } from "react";

const useGiftFinderDrawer = () => {
    const [isOpen, setIsOpen] = useState(false);

    const openDrawer = useCallback(() => setIsOpen(true), []);
    const closeDrawer = useCallback(() => setIsOpen(false), []);

    return {
        isOpen,
        openDrawer,
        closeDrawer,
    };
};

export default useGiftFinderDrawer;
